export function timeToSeconds(time) {
  const parts = time.split(/:/).map((p) => parseInt(p));
  return (parts[0] * 60 * 60) + (parts[1] * 60) + parts[2];
}

export function secondsToTime(seconds) {
  const _seconds = seconds % 60;
  const _minutes = Math.floor(seconds / 60 % 60);
  const _hours = Math.floor(seconds / 3600 % 60);

  return String(_hours).padStart(2, '0') + ':' + String(_minutes).padStart(2, '0') + ':' + String(_seconds).padStart(2, '0');
}

// Codifica o config do painel em base64 usando bytes UTF-8.
// btoa() puro só aceita Latin-1 e quebra com caracteres fora dessa faixa.
export function encodePanelConfig(config) {
  const json = JSON.stringify(config);
  return btoa(unescape(encodeURIComponent(json)));
}

// Decodifica o config do painel. O payload normalmente vem em UTF-8, mas links
// antigos gerados pelo SearchStop foram codificados em Latin-1; nesse caso a
// decodificação UTF-8 falha (URIError) e usamos a string binária como está.
export function decodePanelConfig(data) {
  const binary = atob(data);
  let json;
  try {
    json = decodeURIComponent(escape(binary));
  } catch (e) {
    json = binary;
  }
  return JSON.parse(json);
}
